<template>
  <div class="hoaccu">
    <div class="container">
      <div class="sideBar">
        <div class="topMenu">
          <div class="rootName">{{currentRootMenu}}</div>
          <div
            :class="{menuItem:true,activeMenu:(activeMenuName === menu.name) ? true : false}"
            v-for="(menu,index) in currentMenu"
            :key="index"
            @click="$router.push({name:menu.name})">
            {{menu.name}}
          </div>
        </div>
        <div class="bottomRecommend topMenu">
          <div class="rootName">推荐产品</div>
          <div style="margin-top:15px">
            <div class="recommendItem"
                 @click="productRouter(item)"
                 v-for="item in recommendInfo"
                 :key="item.id">
              <div class="itemImg">
                <img v-lazy="'http://file.hoaccu.com/' + item.img" :alt="item.img">
              </div>
              <div class="itemTitle">
                {{item.title}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="breadCrumb">
          <div class="title">
            {{currentRootMenu}}
          </div>
          <div class="crumb">
            您当前所在的位置：
            <span v-for="(item,index) in breadCrumb"
              :key="index">
              <span @click="$router.push({name:item.name})">{{item.name}}</span>
              {{index === breadCrumb.length -1  ? "" : "->"}}
            </span>
          </div>
        </div>
        <div class="content">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    getProductInfo,
    getProductImg
  } from "@/api/hoaccu";

  export default {
    name: "",
    data() {
      return {
        menuList: [],
        currentMenu: [],
        currentRootMenu: "",
        activeMenuName: "",
        recommendInfo: [],
        breadCrumb:[],
        dictList:{
          millingMachine:"铣床",
          grindingMachine:"磨床",
          radialDrillingMachine:"摇臂钻床",
          digitalControlledLathe:"数控车床",
        }
      }
    },
    created() {
      this.getRecommendProduct();
    },
    methods: {
      productRouter(item){
        console.log(item);
        if (item.type === 'millingMachine' || item.type === 'grindingMachine' || item.type === 'radialDrillingMachine' || item.type === 'digitalControlledLathe'){
          this.$router.push({
            name:this.dictList[item.type] + '详情',
            params:{
              id:item.id
            }
          })
        }else {
          this.$router.push({
            path:`/${item.type}/${item.subType}/detail/${item.id}`
          })
        }
      },
      getCurrentMenu() {
        this.currentRootMenu = this.$route.matched.filter(item => item.path !== "")[0].name;
        this.currentMenu = this.menuList.filter(item => item.name === this.currentRootMenu)[0].subMenuList;
      },
      getRecommendProduct() {
        getProductInfo({
          page: 1,
          pageSize: 2,
          condition: []
        }).then(res => {
          const getProductImgInfo = async () => {
            for (let i = 0; i < res.data.data.length; i++) {
              let response = await getProductImg({
                page: 1,
                pageSize: 1,
                condition: [
                  {
                    "key": "pid",
                    "value": res.data.data[i].id
                  }
                ]
              });
              if (response.status === 200 && response.data.data.length) {
                this.recommendInfo.push({
                  id: res.data.data[i].id,
                  title: res.data.data[i].title,
                  type: res.data.data[i].type,
                  subType: res.data.data[i].subType,
                  img: response.data.data[0].img
                })
              }else {
                this.recommendInfo.push({
                  id: res.data.data[i].id,
                  title: res.data.data[i].title,
                  type: res.data.data[i].type,
                  subType: res.data.data[i].subType,
                  img: ""
                })
              }
            }
          };
          getProductImgInfo();
        })
      }
    },
    watch: {
      $route: {
        deep: true,
        immediate: true,
        handler(val) {
          this.menuList = JSON.parse(sessionStorage.getItem('menuList'));
          this.getCurrentMenu();
          this.activeMenuName = this.$route.meta.activeSubName ? this.$route.meta.activeSubName : this.$route.name;
          this.breadCrumb = this.$route.matched.filter(item=>item.path !== "");
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .hoaccu {
    .container {
      width: 1200px;
      margin: 20px auto;
      display: flex;
      justify-content: space-between;

      .sideBar {
        width: 235px;

        .topMenu {
          width: 100%;
          border: 1px solid #000;
          background: #eee;

          .rootName {
            height: 45px;
            background: #333;
            color: #fff;
            font-weight: bold;
            text-align: center;
            line-height: 45px;
            font-size: 16px;
            user-select: none;
          }

          .menuItem {
            height: 40px;
            line-height: 40px;
            cursor: pointer;
            user-select: none;
            color: #666;
            text-align: center;

            &:not(:last-child) {
              border-bottom: 1px #ccc dotted;
            }

            &:hover {
              background: #ccc;
              color: #fff;
            }
          }

          .activeMenu {
            background: #ccc;
            color: #fff;
          }
        }

        .bottomRecommend {
          margin-top: 20px;
          background: #fff;
          border: 1px solid #ccc;
          .recommendItem{
            cursor: pointer;
            user-select: none;
            width: 200px;
            margin: 0 auto 30px auto;
            &:hover .itemImg{
              border: 1px solid orange;
            }
            &:hover .itemTitle{
              color: orange;
            }
            .itemImg{
              width: 200px;
              border: 1px solid #ccc;
              text-align: center;
              height: 125px;
              overflow: hidden;
              &>img{
                height: 123px;
              }
            }
            .itemTitle{
              margin-top: 5px;
              width: 200px;
              text-align: center;
              font-size: 13px;
              color: #333;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
          }
        }
      }

      .main {
        width: 920px;
        .breadCrumb{
          width: 100%;
          background: #eee;
          border: 1px dotted #ccc;
          display: flex;
          justify-content: space-between;
          height: 40px;
          .title{
            line-height: 40px;
            font-weight: bold;
            padding-left: 10px;
            user-select: none;
          }
          .crumb{
            line-height: 40px;
            padding-right: 10px;
            &>span{
              user-select: none;
            }
            &>span>span{
              font-size: 12px;
              cursor: pointer;
              user-select: none;
            }
          }
        }
      }
    }
  }
</style>
